export type VerifyPayload = {
  gradesVerified: "Y" | "N";
  paystubVerified: "Y" | "N";
  receiptVerified: "Y" | "N";
  scheduleVerified: "Y" | "N";
  verified5: "Y" | "N"; // travelReceipts
  verified6: "Y" | "N"; // other
};

export const buildVerifyPayload = (selected: string[]): VerifyPayload => {
  const flag = (key: string): "Y" | "N" => (selected.includes(key) ? "Y" : "N");
  return {
    gradesVerified: flag("gradesVerified"),
    paystubVerified: flag("paystubVerified"),
    receiptVerified: flag("receiptVerified"),
    scheduleVerified: flag("scheduleVerified"),
    verified5: flag("travelReceipts"),
    verified6: flag("other"),
  };
};
